import { render, staticRenderFns } from "./ZWhatsappSvg.vue?vue&type=template&id=ed969960&scoped=true&"
import script from "./ZWhatsappSvg.vue?vue&type=script&lang=js&"
export * from "./ZWhatsappSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed969960",
  null
  
)

export default component.exports